import {
  LocalOnInvalidReply,
  LocalOnRetriesExhausted,
  LocalOnTimeout,
  OnInvalidReply,
  OnRetriesExhausted,
  OnTimeout,
} from '@/app/module/campaigns/types'

import { fromFailure, fromInvalid, fromTimeout, toFailure, toInvalid, toTimeout } from './response-configs-utils'

export type SmsConfigs = {
  onInvalidReply?: OnInvalidReply
  onTimeout: OnTimeout
  retries: number
  onRetriesExhausted: OnRetriesExhausted
}

export type SmsConfigsState = {
  onInvalidReply?: LocalOnInvalidReply
  onTimeout: LocalOnTimeout
  retries: number
  onRetriesExhausted: LocalOnRetriesExhausted
}

export const fromConfigs = (configs: SmsConfigs): SmsConfigsState => ({
  onInvalidReply: configs.onInvalidReply ? fromInvalid(configs.onInvalidReply) : undefined,
  onTimeout: fromTimeout(configs.onTimeout),
  retries: configs.retries,
  onRetriesExhausted: fromFailure(configs.onRetriesExhausted),
})

export const toConfigs = (state: SmsConfigsState): SmsConfigs => {
  if (!state.onInvalidReply) {
    return {
      onTimeout: toTimeout(state.onTimeout),
      retries: state.retries,
      onRetriesExhausted: toFailure(state.onRetriesExhausted),
    }
  }
  return {
    onInvalidReply: toInvalid(state.onInvalidReply),
    onTimeout: toTimeout(state.onTimeout),
    retries: state.retries,
    onRetriesExhausted: toFailure(state.onRetriesExhausted),
  }
}
